export interface IUpload {
  updatedOrderObj: any;
  documentNamesArray: any[];
  uploadArray: any[];
  error: string | null;
}

export const fileUploader = (
  files: { name: string; size: number }[],
  selected: any[],
  order: any
): IUpload => {
  const orderObj = { ...order };
  const uploadArray = [];
  const orderDocArray = [];
  const documentNamesArray = [];
  let error = null;
  for (let i = 0; i < files.length; i++) {
    const localDocument: any = {
      Id: undefined,
      uploading: true,
      errorUploading: false,
      Name: files[i].name,
      ImageSize: files[i].size,
      ImageType: 'pdf',
      File: files[i],
      Location: 'local',
    };
    const orderDoc: any = {
      Id: undefined,
      uploading: true,
      errorUploading: false,
      Name: files[i].name,
      ImageSize: files[i].size,
      ImageType: 'pdf',
      Location: 'local',
    };
    for (let i2 = 0; i2 < selected.length; i2++) {
      if (selected[i2].Name === files[i].name) {
        error = 'This file already exists.';
        break;
      }
    }
    documentNamesArray.push(localDocument.Name);
    uploadArray.push(localDocument);
    orderDocArray.push(orderDoc);
  }

  const updatedOrderObj = Object.assign({}, orderObj, {
    OrderDetails: {
      ...orderObj.OrderDetails,
      Documents: [...selected, ...orderDocArray],
    },
  });
  return {
    updatedOrderObj: updatedOrderObj,
    documentNamesArray: documentNamesArray,
    uploadArray: uploadArray,
    error: error,
  };
};
